interface CorrespondanceLevel {
  valueId: string;
  level: number;
}

// This function format Data to a hierarchical array
// Example: ["Parent", "Child1", "ChildOfChild1", valueAffected]
function formatDataToHierachicalDataArray(
  data: any[],
  correspondanceArray: CorrespondanceLevel[],
  arrayToReturn: any[]
): void {
  // Sorted array in function of the correspondanceLevel
  const sortedCorrespondanceArray = correspondanceArray.sort((a, b) => a.level - b.level);

  data.map((dataItem) => {
    const tmpDataItemArray: any[] = [];
    sortedCorrespondanceArray.map(({ valueId }) => {
      if (dataItem.hasOwnProperty(valueId) && dataItem[valueId] !== null) {
        tmpDataItemArray.push(dataItem[valueId]);
      } else if (dataItem.hasOwnProperty(valueId) && dataItem[valueId] == null) {
        tmpDataItemArray.push(0);
      }
    });
    arrayToReturn.push(tmpDataItemArray);
  });
}

// This function format Hierarchical array to an object tree
// Example: {"Parent": {"Child1" : {"ChildOfChild1": valueAffected}}}
function recursiveFormatHierarchicalArrayToObjectTree(
  rowToFormat: any[],
  objectToReturn: any,
  recusiveIndex?: number
): void {
  let item;
  const rowLength = rowToFormat.length;
  
  for (let j = recusiveIndex || 0; j < rowLength; j += 1) {
    item = rowToFormat[j];
    // if rowToFormat doesn't have a final value (ex : ["S1","S2","S3"]), put an empty object
    if (!objectToReturn[item]) {
      objectToReturn[item] = {};
    }
    // if rowToFormat has a final value, put the value in the last string object
    if (typeof rowToFormat[j + 1] === "number" && j + 1 === rowLength - 1) {
      objectToReturn[item] = rowToFormat[j + 1];
      j += 1;
    } else {
      // else, go down in the hierarchy
      recursiveFormatHierarchicalArrayToObjectTree(rowToFormat, objectToReturn[item], j + 1);
      j = rowLength;
    }
  }
}

// This function format ObjectTree to an Amcharts children's typed array
// -> [{ name: "Parent", children:[{ name: "Child1", children: [{ name: "ChildOfChild1", value: valueAffected}]}]}]
function recursiveFormatObjTreeToAmchartsChildrenArray(
  nameParent: string,
  objToFormat: any,
  arrayToReturn: any[]
): void {
  const objKeys = Object.keys(objToFormat);
  const childrenArray: any[] = [];
  
  if (objKeys && objKeys.length) {
    objKeys.map((objKey) => {
      const childrenObj =
        typeof objToFormat[objKey] === "object" && Object.keys(objToFormat[objKey]).length === 0
          ? 0
          : objToFormat[objKey];
      const isEmptyObjectOrNumber =
        typeof objToFormat[objKey] === "number" ||
        (typeof objToFormat[objKey] === "object" && Object.keys(objToFormat[objKey]).length === 0);

      if (isEmptyObjectOrNumber) {
        childrenArray.push({ name: objKey, value: childrenObj });
      } else if (
        typeof objToFormat[objKey] === "object" &&
        Object.keys(objToFormat[objKey]).length
      ) {
        recursiveFormatObjTreeToAmchartsChildrenArray(objKey, objToFormat[objKey], childrenArray);
      }
    });
    arrayToReturn.push({ name: nameParent, children: childrenArray });
  } else {
    arrayToReturn.push({ name: nameParent, value: objToFormat });
  }
}

export function formatETLDataToAmchartArray(
  etlData: any[],
  valueCorrespondanceArray: CorrespondanceLevel[]
): any[] {
  const hierarchicalDataArray: any[] = [];
  formatDataToHierachicalDataArray(etlData, valueCorrespondanceArray, hierarchicalDataArray);
  
  const objectTreeData: any = {};
  hierarchicalDataArray.map((hierarchicalDataItem) => {
    recursiveFormatHierarchicalArrayToObjectTree(hierarchicalDataItem, objectTreeData);
  });

  const finalArrayData: any[] = [];
  const tmpObjKeys = Object.keys(objectTreeData);

  tmpObjKeys.map((tmpObjKey) => {
    recursiveFormatObjTreeToAmchartsChildrenArray(tmpObjKey, objectTreeData[tmpObjKey], finalArrayData);
  });

  return finalArrayData;
}

export function formatDataAndGroupByToTreeCorrespondanceLevel(
  data: string | string[],
  groupBy: string | string[]
): CorrespondanceLevel[] {
  const formattedArray: CorrespondanceLevel[] = [];

  if (groupBy && (Array.isArray(groupBy) ? groupBy.length : true)) {
    if (Array.isArray(groupBy)) {
      groupBy.forEach((id) => formattedArray.push({ valueId: id, level: formattedArray.length }));
    } else {
      formattedArray.push({ valueId: groupBy, level: formattedArray.length });
    }
  }

  if (data && (Array.isArray(data) ? data.length : true)) {
    if (Array.isArray(data)) {
      data.forEach((id) => formattedArray.push({ valueId: id, level: formattedArray.length }));
    } else {
      formattedArray.push({ valueId: data, level: formattedArray.length });
    }
  }

  return formattedArray;
}
